// @mui
import { Theme, SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import TablePagination, { TablePaginationProps } from '@mui/material/TablePagination';

// ----------------------------------------------------------------------

type Props = {
  dense?: boolean;
  onChangeDense?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: SxProps<Theme>;
};

export default function TablePaginationCustom({
  dense,
  onChangeDense,
  // rowsPerPageOptions = [5, 10, 25],
  rowsPerPageOptions = [15],
  sx,
  ...other
}: Props & TablePaginationProps) {
  return (
    // <Box sx={{ position: 'relative'}}>
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#E5E4E2', height: '40px' }}>
      {/* <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        {...other}
        sx={{
          borderTopColor: 'transparent',
          backgroundColor: '#E5E4E2',
        }}
      /> */}

      {onChangeDense && (
        <FormControlLabel
          label="Dense"
          control={<Switch checked={dense} onChange={onChangeDense} />}
          sx={{
            pl: 2,
            py: 1.5,
            top: 0,

            display: 'none',

            position: {
              sm: 'absolute',
            },
          }}
        />
      )}


<Box sx={{ margin: '0', flexGrow: 1 }}>
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          {...other}
          sx={{
            borderTopColor: 'transparent',
            // backgroundColor: '#E5E4E2',    
            marginLeft: 'auto', 
          }}
        />
      </Box>


    </Box>
  );
}
